/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParagraphChangeDto } from './ParagraphChangeDto';
import {
    ParagraphChangeDtoFromJSON,
    ParagraphChangeDtoFromJSONTyped,
    ParagraphChangeDtoToJSON,
    ParagraphChangeDtoToJSONTyped,
} from './ParagraphChangeDto';
import type { AnnexChangeDto } from './AnnexChangeDto';
import {
    AnnexChangeDtoFromJSON,
    AnnexChangeDtoFromJSONTyped,
    AnnexChangeDtoToJSON,
    AnnexChangeDtoToJSONTyped,
} from './AnnexChangeDto';

/**
 * 
 * @export
 * @interface WorksAgreementComparisonDto
 */
export interface WorksAgreementComparisonDto {
    /**
     * The last signed version below the requested one, the base of the comparison.
     * @type {number}
     * @memberof WorksAgreementComparisonDto
     */
    previousVersionNumber: number;
    /**
     * 
     * @type {Array<ParagraphChangeDto>}
     * @memberof WorksAgreementComparisonDto
     */
    paragraphs: Array<ParagraphChangeDto>;
    /**
     * 
     * @type {Array<AnnexChangeDto>}
     * @memberof WorksAgreementComparisonDto
     */
    annexes: Array<AnnexChangeDto>;
}

/**
 * Check if a given object implements the WorksAgreementComparisonDto interface.
 */
export function instanceOfWorksAgreementComparisonDto(value: object): value is WorksAgreementComparisonDto {
    if (!('previousVersionNumber' in value) || value['previousVersionNumber'] === undefined) return false;
    if (!('paragraphs' in value) || value['paragraphs'] === undefined) return false;
    if (!('annexes' in value) || value['annexes'] === undefined) return false;
    return true;
}

export function WorksAgreementComparisonDtoFromJSON(json: any): WorksAgreementComparisonDto {
    return WorksAgreementComparisonDtoFromJSONTyped(json, false);
}

export function WorksAgreementComparisonDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorksAgreementComparisonDto {
    if (json == null) {
        return json;
    }
    return {
        
        'previousVersionNumber': json['previousVersionNumber'],
        'paragraphs': ((json['paragraphs'] as Array<any>).map(ParagraphChangeDtoFromJSON)),
        'annexes': ((json['annexes'] as Array<any>).map(AnnexChangeDtoFromJSON)),
    };
}

export function WorksAgreementComparisonDtoToJSON(json: any): WorksAgreementComparisonDto {
    return WorksAgreementComparisonDtoToJSONTyped(json, false);
}

export function WorksAgreementComparisonDtoToJSONTyped(value?: WorksAgreementComparisonDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'previousVersionNumber': value['previousVersionNumber'],
        'paragraphs': ((value['paragraphs'] as Array<any>).map(ParagraphChangeDtoToJSON)),
        'annexes': ((value['annexes'] as Array<any>).map(AnnexChangeDtoToJSON)),
    };
}

